import { useState } from 'react';

/**
 * Selection for a pool's creators, held outside the table so it survives refetches.
 */
export function usePoolCreatorSelection() {
    const [selectedAccountIds, setSelectedAccountIds] = useState<Set<number>>(() => new Set());

    const toggleCreator = (accountId: number) => {
        setSelectedAccountIds((previous) => {
            const next = new Set(previous);
            if (next.has(accountId)) {
                next.delete(accountId);
            } else {
                next.add(accountId);
            }

            return next;
        });
    };

    const selectCreators = (accountIds: number[]) => {
        setSelectedAccountIds(new Set(accountIds));
    };

    const deselectCreators = (accountIds: number[]) => {
        setSelectedAccountIds((previous) => {
            const next = new Set(previous);
            accountIds.forEach((accountId) => next.delete(accountId));

            return next;
        });
    };

    const clearSelection = () => {
        setSelectedAccountIds(new Set());
    };

    return {
        selectedAccountIds,
        toggleCreator,
        selectCreators,
        deselectCreators,
        clearSelection,
    };
}
